export default [
  {
    path: '/service',
    name: 'service',
    component: () => import('@views/service/index.vue'),
    meta: {
      title: '服务'
    }
  },
  {
    path: '/service/security',
    name: 'security',
    component: () => import('@views/service/security.vue'),
    meta: {
      title: '保障服务'
    }
  },
  {
    path: '/service/serviceList',
    name: 'serviceList',
    component: () => import('@views/service/serviceList.vue'),
    meta: {
      title: '资讯'
    }
  },
  {
    path: '/service/fileDownload',
    name: 'fileDownload',
    component: () => import('@views/service/fileDownload.vue'),
    meta: {
      title: '文件下载'
    }
  },
  {
    path: '/service/detail',
    name: 'detail',
    component: () => import('@views/service/detail.vue'),
    meta: {
      title: '内容详情'
    }
  },
  {
    path: '/service/information',
    name: 'detail',
    component: () => import('@views/service/information.vue'),
    meta: {
      title: '内容详情'
    }
  },
  {
    path: '/service/addCompany',
    name: 'addCompany',
    component: () => import('@views/service/addCompany.vue'),
    meta: {
      title: '商家入驻'
    }
  },
  {
    path: '/trainingInfo',
    name: 'trainingInfo',
    component: () => import('@views/securityService/trainingInfo.vue'),
    meta: {
      title: '详情'
    }
  },
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: () => import('@views/securityService/courseDetail.vue'),
    meta: {
      title: '学习培训详情'
    }
  },
  {
    path: '/securityService',
    name: 'securityService',
    component: () => import('@views/securityService/index.vue'),
    meta: {
      title: '保障服务'
    }
  },
  {
    path: '/trainingDetail',
    name: 'trainingDetail',
    component: () => import('@views/securityService/trainingDetail.vue'),
    meta: {
      title: '详情'
    }
  },
]
